import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import { Checkbox, Chip, FormControl, FormControlLabel, FormHelperText, FormLabel, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField, Typography, useTheme } from '@mui/material';
import { Close, SearchOutlined } from '@mui/icons-material';
import { font } from '../../styles/font';
import { useEffect, useState } from 'react';
import { useApplicationContext } from '../../context/ApplicationContext';
import { getProjectCategoryList_API, getProjectDetail_API, getProjectList_API, getProjectSubcategoryList_API, updateProject_API } from '../../api/controller/ProjectController';
import { HttpStatusCode } from 'axios';
import { Entity_Label, Severity } from '../../constant/ApplicationVariables';
import useErrorHandler from '../../api/errorHandler/useErrorHandler';
import { useTranslation } from 'react-i18next';
import { ProjectCustomIcon } from '../styled/CustomIcons';

export default function EditProgramComponent({ open, handleClose, handleContinue }) {
    const { projectList, setProjectList, handleSnackbar, activeProject, setActiveProject, } = useApplicationContext();
    const theme = useTheme();
    const errorHandler = useErrorHandler();
    const { t } = useTranslation('translation', { keyPrefix: 'project' });

    const [projectData, setProjectData] = useState(activeProject);
    const [error, setError] = useState(null);
    const [activeProjectCategory, setActiveProjectCategory] = useState(null);
    const [activeProjectSubcategory, setActiveProjectSubcategory] = useState(null);

    const [isLoading, setIsLoading] = useState(false);

    const [categoryList, setCategoryList] = useState([]);
    const [subCategoryList, setSubCategoryList] = useState([]);

    const toggleDrawer = () => {
        handleClose();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        validateInputs();
    }

    const validateInputs = () => {
        let isValid = true;
        const errorObject = {};

        if (!projectData?.name || projectData?.name?.length < 3 || projectData?.name?.length > 20) {
            errorObject.name = "Name must be between 3 and 20 characters long.";
            isValid = false;
        } else {
            delete errorObject.name;
        }

        if (!projectData?.description) {
            errorObject.description = "Description is required.";
            isValid = false;
        } else {
            delete errorObject.description;
        }

        if (!projectData?.categoryName) {
            errorObject.categoryName = "Category is required.";
            isValid = false;
        } else {
            delete errorObject.categoryName;
        }

        if (projectData?.categoryName && !projectData?.subCategoryName) {
            errorObject.subCategoryName = "Sub Category is required.";
            isValid = false;
        } else {
            delete errorObject.subCategoryName;
        }

        setError(errorObject);
        return isValid && handleUpdate();
    };

    const handleCheckButtonDisable = () => {
        let disable = false

        if (projectData?.name !== activeProject?.name) {
            disable = true
        }
        if (projectData?.description !== activeProject?.description) {
            disable = true
        }
        if (projectData?.categoryName !== activeProject?.categoryName) {
            disable = true
        }
        if (projectData?.subCategoryName !== activeProject?.subCategoryName) {
            disable = true
        }
        if (projectData?.status !== activeProject?.status) {
            disable = true
        }
        if (projectData?.useCasePrefix !== activeProject?.useCasePrefix) {
            disable = true
        }
        if (projectData?.userStoryPrefix !== activeProject?.userStoryPrefix) {
            disable = true
        }
        if (projectData?.testCasePrefix !== activeProject?.testCasePrefix) {
            disable = true
        }

        return disable;
    }

    const handleChange = (e) => {
        if (e.target.name === "categoryName" || e.target.name === "subCategoryName") {
            setProjectData({ ...projectData, [e.target.name]: e.target.value?.name });
        } else {
            setProjectData({ ...projectData, [e.target.name]: e.target.value });
        }

    }

    const handleUpdate = () => {
        handleContinue(projectData);
    }

    const handleGetCategoryList = async () => {
        try {


            const response = await getProjectCategoryList_API();

            if (response.status === HttpStatusCode.Ok) {
                setCategoryList(response.data);

                // handleSnackbar(response.message, Severity.success)
            }

            if (response) {
                errorHandler(response);
            }


            console.log(response, "categoryreponse data")
        } catch (error) {
            console.log(error, "categoryreponse errorr")
        }
    }

    const handleGetsubCategoryList = async () => {
        try {


            let query = `parentName=${projectData?.categoryName}`;

            const response = await getProjectSubcategoryList_API(query);

            if (response.status === HttpStatusCode.Ok) {
                setSubCategoryList(response.data);
                setProjectData({ ...projectData, "subCategoryName": response.data[0]?.name });

                // handleSnackbar(response.message, Severity.success)
            }

            if (response) {
                errorHandler(response);
            }



            console.log(response, "subcategoryreponse data")
        } catch (error) {
            console.log(error, "subcategoryreponse errorr")
        }
    }

    const handleGetProjectDetail = async () => {
        try {
            setIsLoading(true);

            let query = `name=${activeProject?.name}`

            const response = await getProjectDetail_API(query);

            if (response.status === HttpStatusCode.Ok) {
                setProjectData(response.data)
                // handleSnackbar(response.message, Severity.success)
            }

            if (response) {
                errorHandler(response, setIsLoading);
            }

            console.log(response, "handleGetProjectDetail data")
        } catch (error) {
            console.log(error, "handleGetProjectDetail errorr")
        } finally {
            setTimeout(() => {
                setIsLoading(false);
            }, 1000)
        }
    }

    useEffect(() => {
        handleGetCategoryList();
    }, []);

    useEffect(() => {
        if (projectData?.categoryName) {
            handleGetsubCategoryList();
        }
    }, [projectData?.categoryName]);

    // useEffect(() => {
    //     setActiveProjectCategory(categoryList[0]);
    // }, []);

    useEffect(() => {
        // setProjectData(activeProject);
        handleGetProjectDetail();
    }, [activeProject]);

    console.log(projectData, "projectData", activeProject)

    const DrawerList = (
        <Box sx={{ width: 420 }} role="presentation" className="flex flex-col h-full">
            <Box className="flex items-center justify-between px-4 py-2 border-b-2">
                <Typography fontSize={font.size.fs_4} color="textPrimary">{t("editProject")}</Typography>
                <IconButton onClick={() => toggleDrawer()}>
                    <Close />
                </IconButton>
            </Box>
            <Box component="form" onSubmit={handleSubmit} className="flex-1 flex flex-col gap-4 px-4 py-4 overflow-y-auto">


                <FormControl required fullWidth>
                    <FormLabel htmlFor="name">{t("nameText")}</FormLabel>
                    <TextField
                        id="name"
                        name="name"
                        placeholder="Enter name"
                        sx={{ fontSize: font.size.fs_4 }}
                        value={projectData?.name}
                        onChange={handleChange}
                        error={error?.name ? true : false}
                        helperText={error?.name && error?.name}
                    />
                </FormControl>

                <FormControl required fullWidth>
                    <FormLabel htmlFor="description">{t("descriptionText")}</FormLabel>
                    <TextField
                        id="description"
                        name="description"
                        placeholder="Enter description"
                        multiline
                        minRows={4}
                        sx={{ fontSize: font.size.fs_4 }}
                        value={projectData?.description}
                        onChange={handleChange}
                        error={error?.description ? true : false}
                        helperText={error?.description && error?.name}
                    />
                </FormControl>

                {/* project list container */}
                <Box className="flex-1 flex flex-col gap-4 ">



                    <FormControl required fullWidth>
                        <FormLabel htmlFor="description">{Entity_Label.project}</FormLabel>
                        <Box className="flex flex-col">

                            {/* search container */}
                            <Box className="flex flex-col">
                                <TextField
                                    type="search"
                                    placeholder="Search"
                                    slotProps={{
                                        input: {
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchOutlined />
                                                </InputAdornment>
                                            ),
                                        }
                                    }}

                                />
                            </Box>

                            {/* list of projects */}
                            <Box className="flex-1 flex flex-col gap-0 overflow-hidden">

                                <Box className=" flex items-center justify-between px-4 py-2">
                                    <FormControl >
                                        <FormControlLabel
                                            label={"Select All"}
                                            control={<Checkbox />}
                                        />
                                    </FormControl>

                                    <Chip label={`0 / ${projectList?.length}`} />
                                </Box>


                                <Box className="flex-1 flex flex-col gap-0 overflow-y-auto">
                                    {projectList?.map((item, index) => {
                                        return (
                                            <MenuItem key={index} value={item?.name} onClick={() => { }}>
                                                <FormControl fullWidth>
                                                    <FormControlLabel
                                                        label={
                                                            <Box className="flex items-center gap-1">
                                                                <ProjectCustomIcon sx={{ color: theme.palette.secondary.main, fontSize: font.size.fs_4 }} />
                                                                <Typography>{item?.name}</Typography>
                                                            </Box>
                                                        }
                                                        control={<Checkbox />}
                                                    />
                                                </FormControl>
                                            </MenuItem>
                                        )
                                    })}
                                </Box>
                            </Box>





                        </Box>
                    </FormControl>



                </Box>
            </Box>

            <Box className="flex items-center gap-4 px-4 py-4 border-t-2">
                <Button fullWidth variant="outlined" disabled={isLoading || !projectData?.name || !projectData?.description} onClick={() => toggleDrawer()}>{t("discardText")}</Button>
                <Button fullWidth variant="contained" color="secondary" sx={{ color: theme.palette.secondary.contrastText }} disabled={isLoading} onClick={() => handleUpdate()}>{t("updateText")}</Button>
            </Box>

        </Box>
    );

    return (
        <Box>
            <Drawer open={open} onClose={handleClose} anchor="right" variant="temporary">
                {DrawerList}
            </Drawer>
        </Box>
    );
}